import dayjs from 'dayjs';

export function timestamp_seconds(): number {
  return Math.floor(Date.now() / 1000);
}

export function timestamp_ms(): number {
  return Date.now();
}

export function format_time_ms(milliseconds: number): string {
  const MS_IN_SECOND = 1000;
  const MS_IN_MINUTE = MS_IN_SECOND * 60;

  let output = '';

  if (milliseconds < MS_IN_SECOND) {
    output = `${milliseconds.toString().pad(3)} ms`;
  } else if (milliseconds < MS_IN_MINUTE) {
    output = `${(milliseconds / MS_IN_SECOND).toFixed(1).pad(3)}  s`;
  } else {
    output = `${(milliseconds / MS_IN_MINUTE).toFixed(2).pad(3)}  m`;
  }

  return output;
}

export function get_human_readable_duration(value: number): string {
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0 || hours === 0) parts.push(`${minutes}m`);

  return parts.join(' ');
}

export function format_timestamp_YY_MM_DD_HH_mm_ss(timestamp_ms: number): string {
  let timestamp = Math.round(timestamp_ms / 1000);

  return dayjs.unix(timestamp).format('YYYY-MM-DD HH:mm:ss');
}

export function format_timestamp_YY_MM_DD_HH_mm(timestamp_ms: number): string {
  let timestamp = Math.round(timestamp_ms / 1000);

  return dayjs.unix(timestamp).format('YYYY-MM-DD HH:mm');
}

export function format_timestamp_YY_MM_DD(timestamp_ms: number): string {
  let timestamp = Math.round(timestamp_ms / 1000);

  return dayjs.unix(timestamp).format('YYYY-MM-DD');
}

export function format_duration_HH_mm_ss(duration_ms: number) {
  let out = '';

  if (duration_ms <= 0) return out;

  const seconds = Math.floor(duration_ms / 1000) % 60;
  const minutes = Math.floor(duration_ms / (1000 * 60)) % 60;
  const hours = Math.floor(duration_ms / (1000 * 60 * 60));

  out = [hours, minutes, seconds].map(v => String(v).padStart(2, '0')).join(':');

  return out;
}

export function format_timestamp_HH_mm_ss(timestamp_ms: number) {
  let timestamp = Math.round(timestamp_ms / 1000);

  return dayjs.unix(timestamp).format('HH:mm:ss');
}

export function format_time_with_unit(milliseconds: number) {
  let seconds = Math.ceil(milliseconds / 1000);

  const minutes = Math.floor((seconds / 60) % 60);
  const hours = Math.floor(seconds / 3600);

  const pad = (number: number) => String(number).padStart(2, '0');

  return seconds < 60 ? `00m:${pad(seconds)}s` : `${pad(hours)}h:${pad(minutes)}m`;
}

export function get_time_before_utc_midnight() {
  const now = new Date();
  const utc_year = now.getUTCFullYear();
  const utc_month = now.getUTCMonth();
  const utc_date = now.getUTCDate();

  const utc_next_midnight = Date.UTC(utc_year, utc_month, utc_date + 1, 0, 0, 0);
  const nowUtc = now.getTime();

  return utc_next_midnight - nowUtc;
}
